<template>
  <div class="cont indexClasses">
    <div class="classesTitle">
      <img src="../../assets/recommend_class.png" />
      <h2>推荐课程</h2>
      <div class="titleSoft">
        <div v-for="(group, index) of this.groupInfos" :key="index" class="titleSoftItem" :class="this.selectedGroup == index ? 'active' : ''" @click=updateSelectedGroup(index)>{{group.name}}</div>
      </div>
    </div>
    <div class="classesCont">
      <router-link 
      v-for="(course, index) of this.courseList"
       :key="index"
        class="classesItem"
        :to="{path:'/coursedetail', query:{id: course.id}}">
        <img :src="course.cover" />
        <div class="desc">
          <h6>{{course.name}}</h6>
          <p>
            <!--green 报名中 ； red 已结束； blue XX天-->
            <span class="status green">{{course.statusMsg}}</span>
            <span class="status blue">{{course.trainCycle}}天</span>
            <span class="txt">{{course.scope}} {{course.videoTotalCount}}节课</span>
          </p>
          <div class="progress">
            <div class="in" :style="{ width: courseProgress(course) }"></div>
          </div>
          <p class="flex">
            <span class="txt">{{course.applyCount}}/{{course.upperLimit}}</span>
            <span class="money flexItem">¥{{course.money}}</span>
          </p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
// 引入请求类
import { getRecommendCourse } from "../../server/index_main_recommend";

export default {
  data() {
    return {
      courseList: [],
      groupInfos: [],
      selectedGroup: 0,
    };
  },
  mounted() {
    this.fetchCourseList("0");
  },
  methods: {
    async fetchCourseList(groupId) {
      let result = await getRecommendCourse(groupId);
      this.courseList = result.list;
      if (result.cycles.length != 0) {
        this.groupInfos = result.cycles;
      }
    },
    updateSelectedGroup(index) {
      this.selectedGroup = index;
      if (index < this.groupInfos.length) {
        this.fetchCourseList(this.groupInfos[index].id);
      }
    },
    courseProgress(course) {
      let current = course.applyCount;
      let total = course.upperLimit;
      let percent = parseInt((current / total) * 100);
      return percent + "%";
    }
  },
};
</script>

<style scoped>
.cont {
  width: 1200px;
  margin: 0 auto;
}
.indexClasses {
  margin-bottom: 80px !important;
  position: relative;
  z-index: 2;
}
.indexClasses .classesTitle {
  height: 54px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
 .classesTitle img {
  display: inline-block;
  width: 54px;
  height: 54px;
  margin-right: 12px;
}
 .classesTitle h2 {
  display: inline-block;
  color: #003399;
  font-size: 28px;
  font-weight: bold;
  margin-right: 130px;
}
.indexClasses .titleSoft {
  display: inline-block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}
.indexClasses .titleSoftItem {
  display: inline-block;
  margin-right: 40px;
  color: #151515;
  font-size: 16px;
  height: 48px;
  line-height: 48px;
  border-bottom: 6px solid transparent;
  cursor: pointer;
}
.indexClasses .titleSoftItem.active {
  border-color: #003399;
  font-weight: bold;
}
.indexClasses .classesCont {
  width: 1200px;
  font-size: 0;
}
.indexClasses .classesCont.active {
  display: block;
}
</style>